import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../Guard/AuthContext';
import { useContactStore } from '../../hooks/useContactStore';
import SelectComponent from '../Select/Select';
import { ShopOutlined } from '@ant-design/icons';

export const ContactStoresSelect = () => {
  const { currentContactStore, handleChange, currentContactStoreOptions } = useContactStore();
  const { isStoreSelectDisabled } = useContext(AuthContext);
  const [isApiPending, setIsApiPending] = useState(false);

  useEffect(() => {
    const handleLockChange = (e) => {
      setIsApiPending(!!e.detail?.locked);
    };
    window.addEventListener('storeSelectLockChange', handleLockChange);
    return () => window.removeEventListener('storeSelectLockChange', handleLockChange);
  }, []);

  if (!currentContactStoreOptions || currentContactStoreOptions.length < 2) {
    return (
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          minHeight: '44px',
          padding: '0 12px',
          fontSize: '16px',
          color: '#595959',
          fontWeight: 400,
        }}
      >
        <ShopOutlined style={{ fontSize: '16px', color: '#DB3EB1', flexShrink: 0 }} />
        <span style={{ maxWidth: '260px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {currentContactStore?.name ||
            currentContactStore?.displayValue ||
            currentContactStore?.Name ||
            'Магазин'}
        </span>
      </div>
    );
  }

  return (
    <SelectComponent
      options={currentContactStoreOptions}
      value={currentContactStore?.crmId}
      onChange={(e) => handleChange(e)}
      disabled={isStoreSelectDisabled || isApiPending}
    />
  );
};

